import { ApiKeyScopeEnum } from '../entities/apiKeys/apiKeys.interface';
import { MemberRoleEnum } from '../entities/organization/member.enum';
export var SignUpOriginEnum;
(function (SignUpOriginEnum) {
    SignUpOriginEnum["WEB"] = "web";
    SignUpOriginEnum["CLI"] = "cli";
    SignUpOriginEnum["VERCEL"] = "vercel";
})(SignUpOriginEnum || (SignUpOriginEnum = {}));
export var ApiAuthSchemeEnum;
(function (ApiAuthSchemeEnum) {
    ApiAuthSchemeEnum["BEARER"] = "Bearer";
    ApiAuthSchemeEnum["API_KEY"] = "ApiKey";
    ApiAuthSchemeEnum["KEYLESS"] = "Keyless";
})(ApiAuthSchemeEnum || (ApiAuthSchemeEnum = {}));
export var PassportStrategyEnum;
(function (PassportStrategyEnum) {
    PassportStrategyEnum["JWT"] = "jwt";
    PassportStrategyEnum["JWT_CLERK"] = "jwt-clerk";
    PassportStrategyEnum["JWT_BETTER_AUTH"] = "jwt-better-auth";
    PassportStrategyEnum["HEADER_API_KEY"] = "headerapikey";
    PassportStrategyEnum["KEYLESS"] = "keyless";
})(PassportStrategyEnum || (PassportStrategyEnum = {}));
export const NONE_AUTH_SCHEME = 'None';
export var PermissionsEnum;
(function (PermissionsEnum) {
    PermissionsEnum["WORKFLOW_READ"] = "org:workflow:read";
    PermissionsEnum["WORKFLOW_WRITE"] = "org:workflow:write";
    PermissionsEnum["WEBHOOK_READ"] = "org:webhook:read";
    PermissionsEnum["WEBHOOK_WRITE"] = "org:webhook:write";
    PermissionsEnum["ENVIRONMENT_WRITE"] = "org:environment:write";
    PermissionsEnum["API_KEY_READ"] = "org:apikey:read";
    PermissionsEnum["API_KEY_WRITE"] = "org:apikey:write";
    PermissionsEnum["EVENT_WRITE"] = "org:event:write";
    PermissionsEnum["INTEGRATION_READ"] = "org:integration:read";
    PermissionsEnum["INTEGRATION_WRITE"] = "org:integration:write";
    PermissionsEnum["MESSAGE_READ"] = "org:message:read";
    PermissionsEnum["MESSAGE_WRITE"] = "org:message:write";
    PermissionsEnum["PARTNER_INTEGRATION_READ"] = "org:partnerintegration:read";
    PermissionsEnum["PARTNER_INTEGRATION_WRITE"] = "org:partnerintegration:write";
    PermissionsEnum["SUBSCRIBER_READ"] = "org:subscriber:read";
    PermissionsEnum["SUBSCRIBER_WRITE"] = "org:subscriber:write";
    PermissionsEnum["TOPIC_READ"] = "org:topic:read";
    PermissionsEnum["TOPIC_WRITE"] = "org:topic:write";
    PermissionsEnum["BILLING_WRITE"] = "org:billing:write";
    PermissionsEnum["ORG_METADATA_WRITE"] = "org:metadata:write";
    PermissionsEnum["NOTIFICATION_READ"] = "org:notification:read";
    PermissionsEnum["BRIDGE_WRITE"] = "org:bridge:write";
    PermissionsEnum["ORG_SETTINGS_WRITE"] = "org:settings:write";
    PermissionsEnum["ORG_SETTINGS_READ"] = "org:settings:read";
    PermissionsEnum["AGENT_READ"] = "org:agent:read";
    PermissionsEnum["AGENT_WRITE"] = "org:agent:write";
})(PermissionsEnum || (PermissionsEnum = {}));
export const ALL_PERMISSIONS = Object.values(PermissionsEnum);
export const ROLE_PERMISSIONS = {
    [MemberRoleEnum.OWNER]: [
        PermissionsEnum.WORKFLOW_READ,
        PermissionsEnum.WORKFLOW_WRITE,
        PermissionsEnum.AGENT_READ,
        PermissionsEnum.AGENT_WRITE,
        PermissionsEnum.WEBHOOK_READ,
        PermissionsEnum.WEBHOOK_WRITE,
        PermissionsEnum.ENVIRONMENT_WRITE,
        PermissionsEnum.API_KEY_READ,
        PermissionsEnum.API_KEY_WRITE,
        PermissionsEnum.EVENT_WRITE,
        PermissionsEnum.INTEGRATION_READ,
        PermissionsEnum.INTEGRATION_WRITE,
        PermissionsEnum.MESSAGE_READ,
        PermissionsEnum.MESSAGE_WRITE,
        PermissionsEnum.PARTNER_INTEGRATION_READ,
        PermissionsEnum.PARTNER_INTEGRATION_WRITE,
        PermissionsEnum.SUBSCRIBER_READ,
        PermissionsEnum.SUBSCRIBER_WRITE,
        PermissionsEnum.TOPIC_READ,
        PermissionsEnum.TOPIC_WRITE,
        PermissionsEnum.BILLING_WRITE,
        PermissionsEnum.ORG_METADATA_WRITE,
        PermissionsEnum.NOTIFICATION_READ,
        PermissionsEnum.BRIDGE_WRITE,
        PermissionsEnum.ORG_SETTINGS_WRITE,
        PermissionsEnum.ORG_SETTINGS_READ,
    ],
    [MemberRoleEnum.ADMIN]: [
        PermissionsEnum.WORKFLOW_READ,
        PermissionsEnum.WORKFLOW_WRITE,
        PermissionsEnum.AGENT_READ,
        PermissionsEnum.AGENT_WRITE,
        PermissionsEnum.WEBHOOK_READ,
        PermissionsEnum.WEBHOOK_WRITE,
        PermissionsEnum.ENVIRONMENT_WRITE,
        PermissionsEnum.API_KEY_READ,
        PermissionsEnum.API_KEY_WRITE,
        PermissionsEnum.EVENT_WRITE,
        PermissionsEnum.INTEGRATION_READ,
        PermissionsEnum.INTEGRATION_WRITE,
        PermissionsEnum.MESSAGE_READ,
        PermissionsEnum.MESSAGE_WRITE,
        PermissionsEnum.PARTNER_INTEGRATION_READ,
        PermissionsEnum.PARTNER_INTEGRATION_WRITE,
        PermissionsEnum.SUBSCRIBER_READ,
        PermissionsEnum.SUBSCRIBER_WRITE,
        PermissionsEnum.TOPIC_READ,
        PermissionsEnum.TOPIC_WRITE,
        PermissionsEnum.ORG_METADATA_WRITE,
        PermissionsEnum.NOTIFICATION_READ,
        PermissionsEnum.BRIDGE_WRITE,
        PermissionsEnum.ORG_SETTINGS_WRITE,
        PermissionsEnum.ORG_SETTINGS_READ,
    ],
    [MemberRoleEnum.AUTHOR]: [
        PermissionsEnum.WORKFLOW_READ,
        PermissionsEnum.WORKFLOW_WRITE,
        PermissionsEnum.AGENT_READ,
        PermissionsEnum.AGENT_WRITE,
        PermissionsEnum.EVENT_WRITE,
        PermissionsEnum.INTEGRATION_READ,
        PermissionsEnum.INTEGRATION_WRITE,
        PermissionsEnum.MESSAGE_READ,
        PermissionsEnum.SUBSCRIBER_READ,
        PermissionsEnum.SUBSCRIBER_WRITE,
        PermissionsEnum.TOPIC_READ,
        PermissionsEnum.TOPIC_WRITE,
        PermissionsEnum.NOTIFICATION_READ,
        PermissionsEnum.BRIDGE_WRITE,
    ],
    [MemberRoleEnum.VIEWER]: [
        PermissionsEnum.WORKFLOW_READ,
        PermissionsEnum.AGENT_READ,
        PermissionsEnum.INTEGRATION_READ,
        PermissionsEnum.MESSAGE_READ,
        PermissionsEnum.SUBSCRIBER_READ,
        PermissionsEnum.TOPIC_READ,
        PermissionsEnum.NOTIFICATION_READ,
    ],
    [MemberRoleEnum.INTEGRATOR]: [
        PermissionsEnum.WORKFLOW_READ,
        PermissionsEnum.WORKFLOW_WRITE,
        PermissionsEnum.WEBHOOK_READ,
        PermissionsEnum.WEBHOOK_WRITE,
        PermissionsEnum.API_KEY_READ,
        PermissionsEnum.EVENT_WRITE,
        PermissionsEnum.INTEGRATION_READ,
        PermissionsEnum.MESSAGE_READ,
        PermissionsEnum.SUBSCRIBER_READ,
        PermissionsEnum.SUBSCRIBER_WRITE,
        PermissionsEnum.TOPIC_READ,
        PermissionsEnum.TOPIC_WRITE,
        PermissionsEnum.NOTIFICATION_READ,
    ],
    [MemberRoleEnum.OSS_MEMBER]: [],
    [MemberRoleEnum.OSS_ADMIN]: [],
};
/**
 * What an API key of each scope may do. A `trigger` key is what a client system (e.g. a company
 * using this instance to notify its own users) holds: it can send notifications and manage the
 * recipients, but never touch workflows, integrations, keys or environments.
 */
export const API_KEY_SCOPE_PERMISSIONS = {
    [ApiKeyScopeEnum.FULL]: ALL_PERMISSIONS,
    [ApiKeyScopeEnum.TRIGGER]: [
        PermissionsEnum.EVENT_WRITE,
        PermissionsEnum.SUBSCRIBER_READ,
        PermissionsEnum.SUBSCRIBER_WRITE,
        PermissionsEnum.TOPIC_READ,
        PermissionsEnum.TOPIC_WRITE,
        PermissionsEnum.MESSAGE_READ,
        PermissionsEnum.NOTIFICATION_READ,
    ],
};
export function getPermissionsForApiKeyScope(scope) {
    return API_KEY_SCOPE_PERMISSIONS[scope ?? ApiKeyScopeEnum.FULL] ?? ALL_PERMISSIONS;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _assertAllPermissionsUsed = true;
/**
 * The deprecated OSS roles predate RBAC and carried unrestricted access, so they resolve to ADMIN.
 * An existing self-hosted install therefore keeps working after RBAC is switched on, and an admin
 * can hand out the granular `org:*` roles explicitly from there. Mapping them to a lower role
 * instead would silently lock current members out of their own instance.
 */
const LEGACY_ROLE_ALIASES = {
    [MemberRoleEnum.OSS_ADMIN]: MemberRoleEnum.ADMIN,
    [MemberRoleEnum.OSS_MEMBER]: MemberRoleEnum.ADMIN,
};
/** Roles that may be assigned to a member through the API. Owner is implicit, never assignable. */
export const ASSIGNABLE_MEMBER_ROLES = [
    MemberRoleEnum.ADMIN,
    MemberRoleEnum.AUTHOR,
    MemberRoleEnum.INTEGRATOR,
    MemberRoleEnum.VIEWER,
];
export function resolveMemberRole(role) {
    return LEGACY_ROLE_ALIASES[role] ?? role;
}
/** Union of the permissions granted by every role the member holds. */
export function getPermissionsForRoles(roles) {
    if (!roles?.length) {
        return [];
    }
    const granted = new Set();
    for (const role of roles) {
        for (const permission of ROLE_PERMISSIONS[resolveMemberRole(role)] ?? []) {
            granted.add(permission);
        }
    }
    return [...granted];
}
//# sourceMappingURL=auth.js.map